<template>
  <van-popup
      v-model="$attrs.couponView"
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '60%' }"
  >
      <div class="coupon-list">
          <div class="header">
              <span>{{ $t("message.shop.coupon.title") }}</span>
              <div class="closebox" @click="closeClick">
                  <img :src="iconClose" alt="" />
              </div>
          </div>
          <Coupon-list
              class="coupon-main"
              v-on="$listeners"
              v-bind="$attrs"
          ></Coupon-list>
      </div>
  </van-popup>
</template>
<script>
import { Popup } from 'vant';
import CouponList from './coupon-list'
export default {
    components: {
        CouponList,
        [Popup.name]: Popup
    },
    data () {
        return {
            iconClose:
                'https://fr-static.shopshops.top/20200328/close_ticket.6eedbe5648d1c19c.png',
        }
    },
    methods: {
        closeClick () {
            this.$emit('closeClick')
        }
    }
}
</script>
<style lang="less" scoped>
.coupon-list{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .coupon-main{
      flex-grow: 1;
    }
    .header{
        display: flex;
        justify-content: space-between;
        height: 22.5px;
        align-items: center;
        padding: 21px 12px;
        flex: 1;
        span{
            font-size: 16px;
        }
        .closebox{
            width: 16px;
            height: 16px;
            img{
                width: 100%;
                vertical-align: top;
            }
        }
    }
}
</style>